"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getNextAvailabilityList = exports.formatApiDate = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _moment = _interopRequireDefault(require("moment"));
var _api = require("../constants/api");
/**
 * Exported for testing.
 * Formats the given date to something expected by api
 * @param {Date | moment} date - anything usable by `moment` (date, string, momentDate)
 * @returns {string}
 */
const formatApiDate = date => (0, _moment.default)(date).format('YYYY-MM-DD HH:mm:00');

/**
 * Returns a range object to be used by the api
 * @param {string} start - date string
 * @param {number} rangeDays
 * @returns {{ period_start: string, period_end: string}}
 */
exports.formatApiDate = formatApiDate;
const buildRangeFromDate = (start, rangeDays) => ({
  period_start: formatApiDate(start),
  period_end: formatApiDate((0, _moment.default)(start).add(rangeDays, 'days').endOf('day'))
});

/**
 * @param {Object} params
 * @param {String} params.customerCode customer code
 * @param {Object} params.provider
 * @param {Array} params.location_ids
 * @param {String|Moment} params.period_start anything parseable by MomentJs
 * @param {String|Moment} params.period_end anything parseable by MomentJs
 * @param {String} params.purpose
 * @param {String} params.patient_relationship
 * @param {Array} params.visibility
 * * @param {String} params.role
 * @returns {Array} list of appointments
 */
const getAvailabilityList = async _ref => {
  let {
    customerCode,
    location_ids,
    provider,
    period_start,
    period_end,
    purpose,
    patient_relationship,
    visibility,
    role
  } = _ref;
  const res = await _axios.default.get(`/api/availability/${encodeURIComponent(customerCode)}/availability/list`, {
    params: {
      location_codes: location_ids,
      provider_code: provider.id,
      period_start,
      period_end,
      purpose: purpose,
      patient_relationship,
      visibility: visibility.join(''),
      role
    }
  });
  return res.data;
};

/**
 * @param {Object} params
 * @param {String} params.customerCode customer code
 * @param {Object} params.provider
 * @param {Array} params.location_ids
 * @param {String|Moment} params.period_start anything parseable by MomentJs
 * @param {String} params.purpose
 * @param {String} params.patient_relationship
 * @param {Array} params.visibility
 * @returns {Object} api response
 */
const getNext = async _ref2 => {
  let {
    customerCode,
    location_ids,
    provider,
    period_start,
    purpose,
    patient_relationship,
    visibility
  } = _ref2;
  const res = await _axios.default.get(`/api/availability/${encodeURIComponent(customerCode)}/availability/next`, {
    params: {
      location_codes: location_ids,
      provider_code: provider.id,
      period_start: formatApiDate(period_start),
      purpose: purpose,
      patient_relationship: patient_relationship,
      visibility: visibility.join('')
    }
  });
  return res.data;
};

/**
 * Based on params, fetches the next availability appointment from `period_start`
 * and then fetches a list of scheduling appointments starting from that point.
 *
 * @param {Object} params
 * @param {String} params.customerCode customer code
 * @param {Object} params.provider
 * @param {Array} params.location_ids
 * @param {String|Moment} params.period_start anything parseable by MomentJs
 * @param {String} params.purpose
 * @param {String} params.patient_relationship
 * @param {Array} params.visibility
 * @param {String} params.role
 * @returns {Array} list of appointments
 */
const getNextAvailabilityList = async _ref3 => {
  let {
    params
  } = _ref3;
  const nextRes = await getNext(params);
  if (!nextRes || !nextRes.result) {
    return [];
  }
  const {
    start_datetime
  } = nextRes.result;
  const range = buildRangeFromDate(start_datetime, _api.AVAIL_RANGE_DAYS);
  const availRes = await getAvailabilityList({
    ...params,
    period_start: range.period_start,
    period_end: range.period_end
  });
  return availRes.result || [];
};
exports.getNextAvailabilityList = getNextAvailabilityList;